import { GetBusinessAccountPoliciesArgs } from 'types/api/arguments/get-business-account-policies-args'
import { BusinessAccountPoliciesResp } from 'types/api/response/business-account-policies-resp'

import { api } from './api'

export const getBusinessAccountPolicies = ({ businessAccountId }: GetBusinessAccountPoliciesArgs) =>
  api.get<BusinessAccountPoliciesResp>(`/business_accounts/${businessAccountId}/terms`)
